import React from 'react';
import styled from 'styled-components';

const SkillsSection = styled.section`
  padding: 5rem 0;
  background-color: ${props => props.theme.colors.primary.lighter};
`;

const SkillsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const SectionTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.h2};
  margin-bottom: 3rem;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background-color: ${props => props.theme.colors.accent.teal};
  }
`;

const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const SkillCategory = styled.div`
  background-color: ${props => props.theme.colors.primary.background};
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;

const CategoryTitle = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.accent.teal};
  display: flex;
  align-items: center;
  
  &::before {
    content: '${props => props.icon}';
    margin-right: 0.8rem;
    font-size: 1.5rem;
  }
`;

const SkillList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const SkillItem = styled.div``;

const SkillName = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  
  span {
    font-weight: 500;
  }
`;

const SkillBar = styled.div`
  height: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
  
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: ${props => props.level}%;
    background-color: ${props => props.theme.colors.accent.coral};
    border-radius: 4px;
    transition: width 1s ease-in-out;
  }
`;

const Skills = () => {
  const skillCategories = [
    {
      title: "Network Technologies",
      icon: "🌐",
      skills: [
        { name: "Cisco Networking", level: 95 },
        { name: "Juniper Networks", level: 90 },
        { name: "Meraki", level: 85 },
        { name: "Fortinet", level: 80 },
        { name: "BGP/OSPF/EIGRP", level: 90 }
      ]
    },
    {
      title: "Cloud Technologies",
      icon: "☁️",
      skills: [
        { name: "Cloud Engineering", level: 85 },
        { name: "Network Infrastructure", level: 95 },
        { name: "VMware", level: 80 },
        { name: "Data Center Management", level: 85 }
      ]
    },
    {
      title: "Security",
      icon: "🔒",
      skills: [
        { name: "Firewalls", level: 90 },
        { name: "Cisco Umbrella", level: 85 },
        { name: "Cisco ISE", level: 80 },
        { name: "Network Security", level: 90 }
      ]
    },
    {
      title: "General IT",
      icon: "💻",
      skills: [
        { name: "Troubleshooting", level: 95 },
        { name: "Documentation", level: 85 },
        { name: "Project Management", level: 80 },
        { name: "Client Communication", level: 90 }
      ]
    }
  ];

  return (
    <SkillsSection id="skills">
      <SkillsContainer>
        <SectionTitle>Skills & Expertise</SectionTitle>
        <SkillsGrid>
          {skillCategories.map((category, index) => (
            <SkillCategory key={index}>
              <CategoryTitle icon={category.icon}>{category.title}</CategoryTitle>
              <SkillList>
                {category.skills.map((skill, skillIndex) => (
                  <SkillItem key={skillIndex}>
                    <SkillName>
                      <span>{skill.name}</span>
                      <span>{skill.level}%</span>
                    </SkillName>
                    <SkillBar level={skill.level} />
                  </SkillItem>
                ))}
              </SkillList>
            </SkillCategory>
          ))}
        </SkillsGrid>
      </SkillsContainer>
    </SkillsSection>
  );
};

export default Skills;
